import styled from "styled-components";
import { buildColor } from "@tvg/design-system";

export const NextRacesChangesWrapper = styled.div``;

export const ListTitle = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: inset 0 1px 0 ${buildColor("blue", "100")},
    inset 0 -1px 0 ${buildColor("blue", "100")};
  padding: 4px 12px;
  font-size: 14px;
  button {
    width: 40%;
    align-items: flex-end;
  }
`;

export const ListItem = styled.li`
  border-bottom: solid 1px ${buildColor("blue", "100")};
  padding: 0 12px;
`;

export const Title = styled.span`
  color: ${buildColor("grey", "900")};
  font-weight: bold;
`;

export const ChangesContainer = styled.div<{
  isShown: boolean;
  growHeight: number | undefined;
}>`
  height: ${({ isShown, growHeight }) => (isShown ? `${growHeight}px` : 0)};
  overflow: hidden;
  transition: height 0.5s;
`;

export const AnimationWrapper = styled.div``;

export const ListItemHeader = styled.button`
  background: none;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  font-size: 16px;
  width: 100%;
  height: 40px;
`;

export const ListItemHeaderRight = styled.span`
  display: flex;
  flex-direction: row;
  font-size: 14px;
`;

export const NumberOfChanges = styled.span`
  color: ${buildColor("orange", "400")};
`;

export const EmptyCardWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 100px 28px 0;
  > div {
    width: 100%;
  }
`;
